module.exports = __webpack_public_path__ + "img/13_37.a0baee6b.png";